import { Card, Field, Text, Layout } from '@loadsmart/miranda-react'

import { type ShipmentContainer } from '../domain/ShipmentContainer'
import {
  formatContainerSize,
  formatNonRequiredContainerField,
  formatVesselETADate,
} from '../presenters/ContainerPresenter'

export function ContainerDetails({ container }: { container?: ShipmentContainer }) {
  if (!container) {
    return null
  }
  return (
    <Card>
      <Card.Title>Container Details</Card.Title>
      <Card.Divider />
      <Card.Body>
        <Layout.Grid columnGap="spacing-12" rowGap="spacing-6">
          <Field>
            <Field.Label>Container size</Field.Label>
            <Text variant="body-md">{formatContainerSize(container.containerSize)}</Text>
          </Field>
          <Field>
            <Field.Label>Container number</Field.Label>
            <Text variant="body-md">{container.containerNumber}</Text>
          </Field>
          <Field>
            <Field.Label>Ocean line</Field.Label>
            <Text data-testid="ocean-line" variant="body-md">
              {formatNonRequiredContainerField(container.oceanLineScac)}
            </Text>
          </Field>
          <Field>
            <Field.Label>Seal number</Field.Label>
            <Text data-testid="seal-number" variant="body-md">
              {formatNonRequiredContainerField(container.sealNumber)}
            </Text>
          </Field>
          <Field>
            <Field.Label>Vessel</Field.Label>
            <Text data-testid="vessel-name" variant="body-md">
              {formatNonRequiredContainerField(container.vesselName)}
            </Text>
          </Field>
          <Field>
            <Field.Label>Voyage</Field.Label>
            <Text data-testid="voyage-number" variant="body-md">
              {formatNonRequiredContainerField(container.voyageNumber)}
            </Text>
          </Field>
          <Field>
            <Field.Label>Master BOL</Field.Label>
            <Text data-testid="master-bol" variant="body-md">
              {formatNonRequiredContainerField(container.masterBOLNumber)}
            </Text>
          </Field>
          <Field>
            <Field.Label>IMO code</Field.Label>
            <Text data-testid="imo-code" variant="body-md">
              {formatNonRequiredContainerField(container.imoCode)}
            </Text>
          </Field>
          <Field>
            <Field.Label>Vessel ETA</Field.Label>
            <Text data-testid="vessel-eta" variant="body-md">
              {formatVesselETADate(container.vesselETA)}
            </Text>
          </Field>
        </Layout.Grid>
      </Card.Body>
    </Card>
  )
}
